import PropTypes from 'prop-types'
import Error from '@components/error'
import useGolfFacilitiesDataSourceEnabled from '@lib/feature-flags/useGolfFacilitiesDataSourceEnabled'
import { hasPlaySearchQueryParams } from '@lib/play-facility-search/search-play-facilities'
import PlayFacilitySearchQuery from './play-facility-search-query'
import CourseSearchResults from './course-search-results'

export { QUERY_CITY_SEARCH } from './course-search-results.legacy-queries'

export default function CourseSearchResultsWithData(props) {
  const { query, ssrData } = props
  const golfFacilitiesDataSource = useGolfFacilitiesDataSourceEnabled()
  if (!query) return null

  // Explicit null = search shell (no results block). Array (incl. []) = SSR results.
  if (ssrData === null) {
    return null
  }

  if (ssrData !== undefined) {
    return <CourseSearchResults {...props} results={ssrData || []} />
  }

  if (golfFacilitiesDataSource) {
    return <Error statusCode={404} />
  }

  if (!hasPlaySearchQueryParams(query)) {
    return null
  }

  return <PlayFacilitySearchQuery {...props} query={query} />
}

CourseSearchResultsWithData.propTypes = {
  query: PropTypes.shape({
    zipCode: PropTypes.string,
    searchText: PropTypes.string,
    state: PropTypes.string,
  }),
  ssrData: PropTypes.array,
}
